import imgTsirt1 from "../assets/Tshirt1.jpg"
import imgTsirt2 from "../assets/Tshirt2.jpg"
import imgTsirt3 from "../assets/Tshirt3.jpg"
import imgTsirt4 from "../assets/Tshirt4.jpg"
import imgTsirt5 from "../assets/Tshirt5.jpg"
import imgTsirt6 from "../assets/Tshirt6.jpg"
import imgTsirt7 from "../assets/Tshirt7.jpg"
import imgTsirt8 from "../assets/Tshirt8.jpg"
import imgTsirt9 from "../assets/Tshirt9.jpg"
import imgTsirt10 from "../assets/Tshirt10.jpg"
export const TshirtList =[
    {
        id: "t1",
        name: "Jujutsu Kaisen", 
        Price: 669,
        imgsrc:imgTsirt1,
    },
    {
        id: "t2",
        name: "AniSense", 
        Price: 500,
        imgsrc:imgTsirt2,
    },
    {
        id: "t3",
        name: "Anime T-shrt", 
        Price: 850,
        imgsrc:imgTsirt3,
    },
    {
        id: "t4",
        name: "Gojo T-shrt", 
        Price: 569,
        imgsrc:imgTsirt4,
    },
    {
        id: "t5",
        name: "Sasuke T-shrt", 
        Price: 900,
        imgsrc:imgTsirt5,
    },
    {
        id: "t6",
        name: "Itachi T-shrt", 
        Price: 990,
        imgsrc:imgTsirt6,
    },
    {
        id: "t7",
        name: "Kakashi T-shrt", 
        Price: 560,
        imgsrc:imgTsirt7,
    },
    {
        id: "t8",
        name: "Animoda T-shrt", 
        Price: 1190,
        imgsrc:imgTsirt8,
    },
    {
        id: "t9",
        name: "Women T-Shirt", 
        Price: 969,
        imgsrc:imgTsirt9,
    },
    {
        id: "t10",
        name: "Women Animoda", 
        Price: 550,
        imgsrc:imgTsirt10,
    },
    
];